import { kebabCase } from 'lodash-es';
import I18n from 'utils/I18n';
import { ACTIONS } from '../components/ActionButton/ActionButton';
import { CATEGORIES, NEW_ATHLETE_FLOW } from './onboardingConstants';

export const t = (key, params) =>
  I18n.t(`components.onboarding.${key}`, { ...params });

/**
 * IMPORTANT - accounts registered using fb and google start the flow with
 * /google_registered and /facebook_registered (and not /continue)
 *
 * These legacy routes are mapped to reuse the same step as /continue and
 * maintain underscore case by passing the flag isLegacyPath to this method.
 *
 * See - https://github.com/strava/active/blob/583a84e4d54bec7087d0a8ad5ebe8e762ad02a45/app/controllers/onboarding_controller.rb
 */
export const stepToUrl = ({ category, step, isLegacyPath }) => {
  const prefix =
    category === CATEGORIES.existingAthlete
      ? '/athlete/consents'
      : '/onboarding';

  return `${prefix}/${isLegacyPath ? step : kebabCase(step)}`;
};

export const analyticsPageName = (page) => {
  if (page === NEW_ATHLETE_FLOW.createProfile) {
    // page name for the initial onboarding step does not match NEW_ATHLETE_FLOW.createProfile
    // See NEW_ATHLETE_FLOW.createProfile
    return 'account_details';
  }
  if (page === NEW_ATHLETE_FLOW.welcome) {
    return 'onboarding_welcome';
  }
  return page;
};

// actions - "denied" and "approved" trigger permissions creation on the backend
export const isConsentsCreateAction = (action) => {
  return [ACTIONS.denied, ACTIONS.approved].includes(action);
};

export default { t, stepToUrl, isConsentsCreateAction };
